import i18n from "i18next";
import LanguageDetector from "i18next-browser-languagedetector";
import { initReactI18next } from 'react-i18next';
i18n.use(LanguageDetector)
.use(initReactI18next).init({
  // we init with resources
  resources: {
    en: {
      translations: {
        errointegracaocomservicosap:"Please contact customer service servico.clientes@isq.pt",
        Telefone : "Telephone" ,
        adirafaturaeltronica : "Subscribe to the  electronic billing by inserting your email address" ,
        Nome: "Name",
        Nif: "VAT Number" , 
        Pais: "Country" , 
        Morada : "Address" ,
        CodigoPostal : "Postalcode" , 
        Localidade : "City" ,
        NomeComplementar : "Supplementary Name",
        MoradaComplementar : "Supplementary Address",
        Telemovel :"Mobile" ,
        Fax : "Fax" , 
        Email :"E-Mail",
        Site : "Website",
        Observacoes : "Observations" ,
        ContatoFinanceiros : "Financial Contact" ,
        Horario :  "Attendance Time" ,
        CodigoDeCertidaoPermanente : "Commercial Certificate" ,
        GrupoEconomico : "Economic Group" ,
        Cae : "Cae Code" , 
        EmailFaturaEletronica : "Electronic Billing Email" ,
        ComFaturacaoEletronica : "With Electronic Billing?" ,
        Guardar : "Save Data", 
        Submeter : "Submit" , 
        DadosFaturacao : "Data Billing",
        UltimaAtualizacao : "Saved By" ,
        ObrigatorioPeloMenosUm : "You must fill at least one of the fields",
        Validar : "Validate",
        CLIENTE : "Client",
        dadosguardadoscomsucesso : "Data has been successfully saved" , 
        erroguardardados : "Error saving data",
        aguardar : "Saving" ,
        sim : "Yes" ,
        nao : "No",      
        erroaoenviar : "Error to send" , 
        avalidarnif : "Validating VAT" ,
        porfavoraguarde : "Please Wait" , 
        nifvalido : "Valid VAT" ,
        seminformacao : "Don´t Have Information" ,
        seminformacao2 : "Don´t have information in the VIES about that VAT" ,
        clientesubmetidocomsucesso : "customer successfully submitted" , 
        asubmeterdados : "Submiting data"  , 
        osseusdadosforamsubmetidos : "Your data has already been submitted." , 
        data : "Date" ,
        nifnaocorrespondeaopais: "The VAT does not match the chosen country" ,
        codigopostalnaocorrespondeaopais: "The postal code does not match the chosen country" ,
        codigopostalinvalido: "The postal code is not valid",
        emailinvalidocliente : "Customer Email is Invalid" ,
        emailinvalidofaturaeletronica: "Wrong eletronic billing email" ,
        emailinvalidocontatofinanceiro : "Invalid financial contact email" , 
        Aceite :  "Accept" ,
        estado : "State" , 
        Recusada : "Declined" , 
        aceitarfatura : "Accept Electronic Billing" ,
        recusarfatura : "Decline Electronic Billing" , 
        faturarecusadasucesso    : "Electronic Billing successfully declined" , 
        faturaceitesucesso       : "Electronic Billing successfully accepted" , 
        obrigado :  "Thanks" , 
        erroobtercomolinkdeacessofornecido : "Error getting data with the access link provided", 
        cancelarcliente : "Decline",
        pedidoaberturaclientecancelado : "The Client's opening order is canceled" ,
        informacao : "Info"
      } } ,

      pt: {
        translations: {
          errointegracaocomservicosap : "Ocorreu um erro de integração, por favor entre em contacto com o serviço ao cliente servico.clientes@isq.pt" ,
          Nif : "Nif" , 
          Telefone : "Telefone" ,
          Nome: "Nome",
          adirafaturaeltronica : "Aderira à faturação eletrónica introduzindo o endereço de email",
          Pais: "País" , 
          Morada : "Morada" ,
          CodigoPostal : "Código Postal" , 
          Localidade : "Localidade" ,
          NomeComplementar : "Nome Complementar",
          MoradaComplementar : "Morada Complementar",
          Telemovel :"Telemóvel",
          Fax : "Fax" ,
          Email :"E-Mail",
          Site : "Site" ,
          Observacoes : "Observações" ,
          ContatoFinanceiros : "Contato Financeiro" ,
          Horario : "Hórario de atendimento" ,
          CodigoDeCertidaoPermanente : "Código de Certidão Permanente" ,
          GrupoEconomico : "Grupo Económico" ,
          Cae : "Cae" ,
          EmailFaturaEletronica : "Email da Fatura Eletrónica" ,
          ComFaturacaoEletronica  : "Com Faturação Eletrónica?" ,
          Guardar : "Guardar Dados", 
          DadosFaturacao : "Dados de Faturação",
          UltimaAtualizacao : "Última atualização por" ,
          ObrigatorioPeloMenosUm : "Obrigátorio preencher pelo menos um dos campos",
          Validar : "Validar" , 
          CLIENTE : "Cliente",
          dadosguardadoscomsucesso : "Dados guardados com sucesso",
          erroguardardados : "Erro a guardar dados" ,
          aguardar : "A guardar" , 
          sim : "Sim" ,
          nao : "Não" , 
          erroaoenviar : "Erro ao enviar" ,
          avalidarnif : "A validar NIF" , 
          porfavoraguarde : "Por Favor Aguarde" ,
          nifvalido  : "Nif Válido" ,
          seminformacao : "Sem Informação" ,
          seminformacao2 : "Não há informação no VIES do nif introduzido" , 
          clientesubmetidocomsucesso : "Cliente submetido com sucesso" , 
          asubmeterdados : "A submeter dados" , 
          osseusdadosforamsubmetidos : "Os seus dados já foram submetidos." , 
          data : "Data" ,
          nifnaocorrespondeaopais: "O Nif inserido não corresponde ao país selecionado" ,
          codigopostalnaocorrespondeaopais: "O código postal inserido não corresponde ao país selecionado" ,
          codigopostalinvalido: "O código postal inserido não é válido" ,
          emailinvalidocliente : "Email do cliente Inválido", 
          emailinvalidofaturaeletronica: "Email da fatura eletrónica errada" , 
          emailinvalidocontatofinanceiro : "Email do contato financeiro inválido", 
          Aceite : "Aceite"  , 
          estado : "Estado" , 
          Recusada : "Recusada" ,
          aceitarfatura : "Aceitar Faturação Eletrónica" ,
          recusarfatura : "Recusar Faturação Eletrónica" ,
          faturarecusadasucesso    : "Faturação eletrónica recusada com sucesso" , 
          faturaceitesucesso       : "Faturação eletrónica aceite com sucesso" , 
          obrigado : "Obrigado" , 
         erroobtercomolinkdeacessofornecido  : "Erro ao obter dados com o link de acesso fornecido",
         cancelarcliente : "Reprovar",
         pedidoaberturaclientecancelado : "O pedido de abertura de cliente foi cancelado" , 
         informacao : "Informação"
        }
    }
  },
 
 

  // have a common namespace used around the full app
  ns: ["translations"],
  defaultNS: "translations",

  keySeparator: true, // we use content as keys

  interpolation: {
    escapeValue: false, // not needed for react!!
    formatSeparator: ","
  },

  react: {
    wait: true
  }
});

export default i18n;